/**
 * LocalPickup - local pickup availability display for a variant.
 * Custom element: <local-pickup>
 *
 * Attributes (from $info):
 *   product-title  String  ""
 *
 * Refs:
 *   [data-ref="close"]  (optional)
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import "./component-ProductOptionPicker.js";
import "./component-DrawerContainer.js";
import "./component-DrawerHeader.js";
import { ThemeComponent } from "./theme.js";
import "./component-ProductButtonOption.js";
import "./vendor.js";
import "./component-ProductDropdownOption.js";
import "./component-FakeDropdown.js";
import "./component-BodyOverlay.js";
class LocalPickup extends ThemeComponent {
  constructor() {
    super(...arguments), this.drawerContainer = null, this.drawerHeader = null;
  }
  init() {
    this.optionChangeListen();
  }
  setEventListeners() {
    var container;
    this.drawerContainer = this.querySelector("drawer-container"), this.drawerHeader = (container = this.drawerContainer) == null ? void 0 : container.querySelector("drawer-header");
    const modalToggle = this.querySelector('[data-ref="modalToggle"]');
    this.$listen(modalToggle, "click", () => {
      var drawer;
      (drawer = this.drawerContainer) == null || drawer.open();
    });
  }
  updateData(variant) {
    (variant == null ? void 0 : variant.title) !== void 0 && fetch(`/variants/${variant == null ? void 0 : variant.id}/?section_id=local-pickup`).then(response => response.text()).then(responseHtml => {
      const pickupSection = new DOMParser().parseFromString(responseHtml, "text/html").querySelector(".shopify-section");
      if (!pickupSection || (this.innerHTML = "", !(variant != null && variant.available))) return;
      this.appendChild(pickupSection);
      const titleElement = this.querySelector('[data-ref="title"]');
      titleElement && (titleElement.innerHTML = `${this.productTitle} - ${variant.title}`), this.classList.add("is-active"), this.setEventListeners();
    }).catch(fetchError => {
      fetchError instanceof Error && this.$log.error(fetchError.message);
    });
  }
  optionChangeListen() {
    var parent;
    const optionPicker = (parent = this.parentElement) == null ? void 0 : parent.querySelector("product-option-picker");
    if (optionPicker) {
      this.$subscribe(optionPicker.onSelectedVariantChange, newVariant => {
        this.updateData(newVariant);
      });
      return;
    }
  }
}
setFunctionName(LocalPickup, "LocalPickup");
const propertyTypes = {
  String
};
LocalPickup.prototype.$name = "LocalPickup";
LocalPickup.prototype.$info = JSON.parse('{"name":"LocalPickup","meta":{"isLegacy":false,"selector":"local-pickup"},"props":[{"attr":"product-title","default":"","reflectAttr":false,"propertyKey":"productTitle","propertyType":"String","propertyTypeName":"String","propertyTsTypeName":"string"}],"refs":[{"selector":"[data-ref=\\"close\\"]","required":false,"propertyKey":"close","propertyType":"Object","propertyTypeName":"Object","propertyTsTypeName":"HTMLButtonElement"}]}');
LocalPickup.prototype.$info.component = LocalPickup;
for (const prop of LocalPickup.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("LocalPickup/LocalPickup.ts", {
  LocalPickup: LocalPickup
}, void 0);